import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';
import PaymentGate from '../components/PaymentGate';
import '../styles/design-system.css';

export default function LocalMeetsPage() {
  const [meets, setMeets] = useState([]);
  const [userProfile, setUserProfile] = useState(null);
  const [userSubscriptionStatus, setUserSubscriptionStatus] = useState('free');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('upcoming');

  // Mock data for demonstration with proper privacy model
  const mockMeets = [
    {
      id: 1,
      title: 'London Pub Night',
      description: 'Join us for a casual evening at a popular London pub. Perfect for meeting fellow travelers and locals.',
      organizer: {
        name: 'Sarah M.',
        photo: '/default-avatar.png',
        personalityType: 'Social Butterfly',
        personalityScore: 85
      },
      date: '2024-02-15',
      time: '19:00',
      endTime: '23:00',
      location: 'Central London',
      fullAddress: 'The Red Lion, 123 High Street, London W1 1AA',
      attendees: [
        { name: 'Mike R.', photo: '/default-avatar.png', personalityType: 'Adventure Seeker', personalityScore: 92 },
        { name: 'Emma L.', photo: '/default-avatar.png', personalityType: 'Cultural Explorer', personalityScore: 78 },
        { name: 'David K.', photo: '/default-avatar.png', personalityType: 'Social Butterfly', personalityScore: 88 }
      ],
      maxAttendees: 15,
      category: 'Social',
      isPaidOnly: true
    },
    {
      id: 2,
      title: 'Manchester Football Match',
      description: 'Watch the big game together! All welcome, whether you\'re a die-hard fan or just want to experience the atmosphere.',
      organizer: {
        name: 'Tom B.',
        photo: '/default-avatar.png',
        personalityType: 'Social Butterfly',
        personalityScore: 90
      },
      date: '2024-02-20',
      time: '15:00',
      endTime: '17:30',
      location: 'Manchester',
      fullAddress: 'Old Trafford, Sir Matt Busby Way, Manchester M16 0RA',
      attendees: [
        { name: 'Lisa P.', photo: '/default-avatar.png', personalityType: 'Adventure Seeker', personalityScore: 85 },
        { name: 'James W.', photo: '/default-avatar.png', personalityType: 'Social Butterfly', personalityScore: 82 }
      ],
      maxAttendees: 20,
      category: 'Sports',
      isPaidOnly: true
    },
    {
      id: 3,
      title: 'Birmingham Museum Visit',
      description: 'Explore the Birmingham Museum & Art Gallery together. Great for culture lovers and history buffs.',
      organizer: {
        name: 'Anna C.',
        photo: '/default-avatar.png',
        personalityType: 'Cultural Explorer',
        personalityScore: 95
      },
      date: '2024-02-25',
      time: '14:00',
      endTime: '16:30',
      location: 'Birmingham',
      fullAddress: 'Birmingham Museum & Art Gallery, Chamberlain Square, Birmingham B3 3DH',
      attendees: [
        { name: 'Robert M.', photo: '/default-avatar.png', personalityType: 'Cultural Explorer', personalityScore: 89 },
        { name: 'Sophie H.', photo: '/default-avatar.png', personalityType: 'Cultural Explorer', personalityScore: 91 }
      ],
      maxAttendees: 12,
      category: 'Culture',
      isPaidOnly: true
    },
    {
      id: 4,
      title: 'Liverpool Local Walk',
      description: 'Explore the historic streets of Liverpool with fellow travelers. Discover hidden gems and local history.',
      organizer: {
        name: 'Mark L.',
        photo: '/default-avatar.png',
        personalityType: 'Adventure Seeker',
        personalityScore: 88
      },
      date: '2024-02-28',
      time: '10:00',
      endTime: '13:00',
      location: 'Liverpool',
      fullAddress: 'Meeting at Liverpool Central Station, Ranelagh Street, Liverpool L1 1QE',
      attendees: [
        { name: 'Helen K.', photo: '/default-avatar.png', personalityType: 'Cultural Explorer', personalityScore: 87 },
        { name: 'Paul R.', photo: '/default-avatar.png', personalityType: 'Adventure Seeker', personalityScore: 91 }
      ],
      maxAttendees: 10,
      category: 'Outdoor',
      isPaidOnly: true
    },
    {
      id: 5,
      title: 'Bristol Dinner Meet & Greet',
      description: 'Enjoy a delicious dinner at a local restaurant while meeting new people. Great for food lovers and social butterflies.',
      organizer: {
        name: 'Rachel S.',
        photo: '/default-avatar.png',
        personalityType: 'Social Butterfly',
        personalityScore: 93
      },
      date: '2024-03-02',
      time: '19:30',
      endTime: '22:00',
      location: 'Bristol',
      fullAddress: 'The Stable, 35-37 Corn Street, Bristol BS1 1HT',
      attendees: [
        { name: 'Daniel M.', photo: '/default-avatar.png', personalityType: 'Social Butterfly', personalityScore: 89 },
        { name: 'Sophie T.', photo: '/default-avatar.png', personalityType: 'Cultural Explorer', personalityScore: 84 }
      ],
      maxAttendees: 8,
      category: 'Food & Drink',
      isPaidOnly: true
    },
    {
      id: 6,
      title: 'Leeds Wetherspoons Meet',
      description: 'Casual meetup at a popular Wetherspoons pub. Perfect for budget-conscious travelers and social drinkers.',
      organizer: {
        name: 'Chris W.',
        photo: '/default-avatar.png',
        personalityType: 'Budget Conscious',
        personalityScore: 86
      },
      date: '2024-03-05',
      time: '20:00',
      endTime: '23:00',
      location: 'Leeds',
      fullAddress: 'The Cuthbert Brodrick, 1 Millennium Square, Leeds LS2 3AD',
      attendees: [
        { name: 'Emma L.', photo: '/default-avatar.png', personalityType: 'Social Butterfly', personalityScore: 88 },
        { name: 'Tom H.', photo: '/default-avatar.png', personalityType: 'Budget Conscious', personalityScore: 85 }
      ],
      maxAttendees: 12,
      category: 'Social',
      isPaidOnly: true
    },
    {
      id: 7,
      title: 'Newcastle Local Music Event',
      description: 'Experience the vibrant local music scene in Newcastle. From indie bands to jazz, there\'s something for everyone.',
      organizer: {
        name: 'Lisa M.',
        photo: '/default-avatar.png',
        personalityType: 'Cultural Explorer',
        personalityScore: 92
      },
      date: '2024-03-08',
      time: '21:00',
      endTime: '01:00',
      location: 'Newcastle',
      fullAddress: 'The Cluny, 36 Lime Street, Ouseburn, Newcastle NE1 2PQ',
      attendees: [
        { name: 'Alex R.', photo: '/default-avatar.png', personalityType: 'Adventure Seeker', personalityScore: 90 },
        { name: 'Sarah K.', photo: '/default-avatar.png', personalityType: 'Cultural Explorer', personalityScore: 87 }
      ],
      maxAttendees: 15,
      category: 'Music',
      isPaidOnly: true
    }
  ];

  useEffect(() => {
    const loadUserProfile = async () => {
      try {
        const currentUser = await getCurrentUser();
        const attributes = await fetchUserAttributes();
        
        // Check subscription status from attributes
        const subscriptionStatus = attributes['custom:subscriptionStatus'] || 'free';
        
        setUserProfile({
          id: currentUser.userId,
          name: attributes.name || 'User',
          email: attributes.email,
          personalityType: attributes['custom:personalityType'],
          personalityScore: attributes['custom:personalityScore']
        });
        
        setUserSubscriptionStatus(subscriptionStatus);
        setMeets(mockMeets);
      } catch (error) {
        console.error('Error loading user profile:', error);
      } finally {
        setLoading(false);
      }
    };

    loadUserProfile();
  }, []);

  const handleJoinMeet = (meetId) => {
    // This would integrate with your backend to actually join the meet
    console.log('Joining meet:', meetId);
    // Show success message or update UI
  };

  const handleInviteToMeet = (meetId, userId) => {
    // This would send an invitation to a free member
    console.log('Inviting user to meet:', meetId, userId);
    // Show invitation sent message
  };

  const renderMeetCard = (meet) => {
    const isPaidUser = userSubscriptionStatus === 'paid' || userSubscriptionStatus === 'premium';
    const canSeeDetails = isPaidUser || !meet.isPaidOnly;
    const canAttend = isPaidUser;

    return (
      <div key={meet.id} className="card p-6 mb-6">
        <div className="flex flex-col md:flex-row gap-6">
          {/* Meet Info */}
          <div className="flex-1">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{meet.title}</h3>
                <p className="text-gray-600 mb-3">{meet.description}</p>
              </div>
              <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                meet.category === 'Social' ? 'bg-blue-100 text-blue-800' :
                meet.category === 'Sports' ? 'bg-green-100 text-green-800' :
                'bg-purple-100 text-purple-800'
              }`}>
                {meet.category}
              </span>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
              <div>
                <p className="text-sm text-gray-500">Date</p>
                <p className="font-medium">{new Date(meet.date).toLocaleDateString()}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Time</p>
                <p className="font-medium">
                  {isPaidUser ? `${meet.time} - ${meet.endTime}` : 'See details to join'}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Location</p>
                <p className="font-medium">{meet.location}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Attendees</p>
                <p className="font-medium">{meet.attendees.length}/{meet.maxAttendees}</p>
              </div>
            </div>

            {canSeeDetails && (
              <div className="mb-4">
                <p className="text-sm text-gray-500 mb-1">Full Address:</p>
                <p className="font-medium text-gray-900">{meet.fullAddress}</p>
              </div>
            )}

            {/* Organizer Info */}
            <div className="flex items-center gap-3 mb-4 p-3 bg-gray-50 rounded-lg">
              <img 
                src={meet.organizer.photo} 
                alt={meet.organizer.name}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div className="flex-1">
                <p className="font-medium">{meet.organizer.name}</p>
                <p className="text-sm text-gray-600">{meet.organizer.personalityType}</p>
                {isPaidUser && (
                  <p className="text-sm text-primary font-medium">{meet.organizer.personalityScore}% Match</p>
                )}
              </div>
            </div>
          </div>

          {/* Attendees Section */}
          <div className="md:w-80">
            <h4 className="font-semibold mb-3">Attendees</h4>
            
            {isPaidUser ? (
              <div className="space-y-3">
                {meet.attendees.map((attendee, index) => (
                  <div key={index} className="flex items-center gap-3 p-2 bg-white border border-gray-200 rounded-lg">
                    <img 
                      src={attendee.photo} 
                      alt={attendee.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div className="flex-1">
                      <p className="font-medium text-sm">{attendee.name}</p>
                      <p className="text-xs text-gray-600">{attendee.personalityType}</p>
                      <p className="text-xs text-primary font-medium">{attendee.personalityScore}% Match</p>
                    </div>
                  </div>
                ))}
                
                {meet.attendees.length < meet.maxAttendees && (
                  <button
                    onClick={() => handleJoinMeet(meet.id)}
                    className="btn btn-primary w-full"
                  >
                    Join This Meet
                  </button>
                )}
              </div>
            ) : (
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <p className="text-sm text-gray-600 mb-3">
                  {meet.attendees.length} people are attending
                </p>
                <p className="text-xs text-gray-500 mb-3">
                  Get the full details and join this meetup!
                </p>
                <PaymentGate 
                  feature="local-meets"
                  userSubscriptionStatus={userSubscriptionStatus}
                  customMessage="Upgrade to see who's attending, get exact location & time, and join this meetup!"
                >
                  <button className="btn btn-secondary w-full">
                    Upgrade to Join
                  </button>
                </PaymentGate>
              </div>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 mt-4 pt-4 border-t border-gray-200">
          {isPaidUser && (
            <>
              <button className="btn btn-primary">
                Join Meet
              </button>
              <button className="btn btn-secondary">
                Contact Organizer
              </button>
            </>
          )}
          
          {!isPaidUser && (
            <PaymentGate 
              feature="local-meets"
              userSubscriptionStatus={userSubscriptionStatus}
              customMessage="Upgrade to join this meetup and see all details!"
            >
              <button className="btn btn-primary">
                Upgrade to Join
              </button>
            </PaymentGate>
          )}
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Loading local meets...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="container py-8">
                  <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Local Meets</h1>
            <p className="text-gray-600">
              Organize group outings for people who prefer not to go out alone, but want to meet as a group of friends.
            </p>
            <div className="mt-3 p-3 bg-blue-50 rounded-lg">
              <p className="text-sm text-blue-800">
                <strong>Privacy Notice:</strong> Free users see general location and meet type. 
                Paid members get exact location, time, and attendee details to join meets.
              </p>
            </div>
          </div>
            
            <PaymentGate 
              feature="organize-meets"
              userSubscriptionStatus={userSubscriptionStatus}
            >
              <button 
                onClick={() => setShowCreateModal(true)}
                className="btn btn-primary"
              >
                Create Local Meet
              </button>
            </PaymentGate>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-8">
        {/* Tabs */}
        <div className="flex border-b border-gray-200 mb-6">
          <button
            onClick={() => setActiveTab('upcoming')}
            className={`px-4 py-2 font-medium ${
              activeTab === 'upcoming' 
                ? 'text-primary border-b-2 border-primary' 
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            Upcoming Meets
          </button>
          <button
            onClick={() => setActiveTab('my-meets')}
            className={`px-4 py-2 font-medium ${
              activeTab === 'my-meets' 
                ? 'text-primary border-b-2 border-primary' 
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            My Meets
          </button>
        </div>

        {/* Meets List */}
        <div className="space-y-6">
          {meets.map(renderMeetCard)}
        </div>

        {/* Empty State */}
        {meets.length === 0 && (
          <div className="text-center py-12">
            <div className="text-6xl mb-4">📍</div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">No Local Meets Yet</h3>
            <p className="text-gray-600 mb-6">
              Be the first to organize a local meetup in your area!
            </p>
            <PaymentGate 
              feature="organize-meets"
              userSubscriptionStatus={userSubscriptionStatus}
            >
              <button 
                onClick={() => setShowCreateModal(true)}
                className="btn btn-primary"
              >
                Create Your First Meet
              </button>
            </PaymentGate>
          </div>
        )}
      </div>

      {/* Create Meet Modal */}
      {showCreateModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-8 max-w-2xl w-full mx-4 max-h-[90vh] overflow-auto">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold">Create Local Meet</h2>
              <button 
                onClick={() => setShowCreateModal(false)}
                className="text-2xl hover:text-gray-600"
              >
                ×
              </button>
            </div>
            
            <form className="space-y-4">
              <div>
                <label className="form-label">Meet Title</label>
                <input type="text" className="form-input" placeholder="e.g., London Pub Night" />
              </div>
              
              <div>
                <label className="form-label">Description</label>
                <textarea className="form-input" rows="3" placeholder="Describe your meetup..."></textarea>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="form-label">Date</label>
                  <input type="date" className="form-input" />
                </div>
                <div>
                  <label className="form-label">Time</label>
                  <input type="time" className="form-input" />
                </div>
              </div>
              
              <div>
                <label className="form-label">Location</label>
                <input type="text" className="form-input" placeholder="City or area" />
              </div>
              
              <div>
                <label className="form-label">Full Address</label>
                <input type="text" className="form-input" placeholder="Full address for paid members" />
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="form-label">Category</label>
                  <select className="form-input">
                    <option>Social</option>
                    <option>Sports</option>
                    <option>Culture</option>
                    <option>Food & Drink</option>
                    <option>Outdoor</option>
                  </select>
                </div>
                <div>
                  <label className="form-label">Max Attendees</label>
                  <input type="number" className="form-input" placeholder="15" />
                </div>
              </div>
              
              <div className="flex gap-3 pt-4">
                <button type="submit" className="btn btn-primary">
                  Create Meet
                </button>
                <button 
                  type="button" 
                  onClick={() => setShowCreateModal(false)}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
} 